<div [innerHTML]="innerHtml()"></div>
